import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import colors from "../../../../colors";
import { Grid, Link, Typography } from "@mui/material";
import { texts } from "../../../../general/texts";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import ButtonGroup from "../../../../general/ButtonGroup";
import { useDispatch, useSelector } from "react-redux";
import { sendGeneralRequest } from "../../../../../features/generalRequest";
import DynamicTaxSelector from "./searchMethods/DynamicTaxSelector";
import SearchFields from "./searchMethods/SearchFields";
import { setSentFrom } from "../../../../../features/utilities/utilitySlice";
import {
  selectMyContractsState,
  setShouldFillFields,
} from "../../../../../features/myContracts/myContractsSlice";

const TaksatOffline = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myContractsSliceState = useSelector(selectMyContractsState);
  const searchMethods = [
    { display: "Individ", value: "Individ" },
    { display: "Biznes", value: "Biznes" },
  ];
  const [textFields, setTextFields] = useState([]);
  const [state, setState] = React.useState({
    service: props.utilityName,
    customerType: searchMethods[0].value,
    token: props.globalDataSliceState.token,
    nuis: "",
    subject: "",
    serial: "",
    search: "",
  });

  const getSearchMethodValue = (value) => {
    setState({
      ...state,
      customerType: value,
    });
  };

  useEffect(() => {
    if (myContractsSliceState.shouldFillFields) {
      setState({
        ...state,
        nuis: props.selectedContractInfo.contract,
        subject: props.selectedContractInfo.service,
      });
      dispatch(setShouldFillFields(false));
    }
  }, [myContractsSliceState.shouldFillFields]);

  ///////////////////DynamicTextSelectorStart/////////////////////////////////

  const handleTextFieldChange = (prop) => (e) => {
    setState({
      ...state,
      [prop]: e.target.value,
    });
  };

  const handleAddTextField = () => {
    setTextFields([
      ...textFields,
      { emertimi: "", kodiEkonomik: "", fee: 0, value: "" },
    ]);
  };

  const handleChange = (index, event) => {
    const { value } = event.target;
    const selectedOption = props.utilitySliceState.listOfTaxes[value];

    const newFields = [...textFields];
    newFields[index] = {
      ...newFields[index],
      emertimi: selectedOption.emertimi,
      kodiEkonomik: selectedOption.kodiEkonomik,
      fee: 0,
      value: "",
    };
    setState((prevState) => ({
      ...prevState,
      search: "",
    }));

    setTextFields(newFields);
  };

  const handleRemoveTextField = (index) => {
    const newFields = [...textFields];
    newFields.splice(index, 1);
    setTextFields(newFields);
  };

  ///////////////////DynamicTextSelectorEnd/////////////////////////////////

  const handleStartTransaction = (sentFrom) => {
    dispatch(
      sendGeneralRequest({
        request: {
          service: state.service,
          customerType: state.customerType,
          token: state.token,
          nuis: state.nuis,
          subject: state.subject,
          serial: state.serial,
          taxes: textFields,
        },
        baseUrlKey: "services",
        endpoint: "TAKSAVENDORE/StartTransactionTaxes",
      })
    );
    dispatch(setSentFrom(sentFrom));
  };

  useEffect(() => {
    dispatch(
      sendGeneralRequest({
        request: {
          token: props.globalDataSliceState.token,
          service: props.utilityName,
        },
        baseUrlKey: "services",
        endpoint: "TAKSAVENDORE/GetListOfTaxes",
      })
    );
  }, []);

  const selectedButtonStyle = {
    backgroundColor: colors.lightOrange,
    color: colors.orange,
    width: "150px",
    height: "40px",
    fontFamily: "GerberaBold",
    textTransform: "none",
    fontSize: "1rem",
    border: "2px solid" + colors.orange,
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: colors.lightOrange,
    },
    "@media (max-width: 899px)": { width: "130px", height: "40px" },
  };

  const defaultButtonStyle = {
    backgroundColor: colors.lightBlue,
    width: "150px",
    height: "40px",
    borderRadius: "10px",
    textTransform: "none",
    fontFamily: "GerberaLight",
    fontSize: "1rem",
    color: colors.darkBlue,
    "&:hover": {
      backgroundColor: colors.lightOrange,
    },
    "@media (max-width: 899px)": { width: "130px", height: "40px" },
  };

  const useStyles = makeStyles({
    mainGrid: {
      padding: "5%",
      paddingTop: "3%",
    },
    utilityName: {
      color: props.utilityInfo.Color,
      fontSize: "1.5rem",
      fontFamily: "GerberaBold",
      paddingTop: "3%",
      paddingLeft: "2%",
    },
    headerBox: {
      backgroundColor: colors.cyan,
      borderRadius: "100%",
      width: "70px",
      height: "70px",
    },
    fieldTitle: {
      color: colors.darkBlue,
      fontSize: "1.2rem",
      fontFamily: "GerberaBold",
      textAlign: "left",
    },
    button: {
      width: "100%",
      color: colors.white,
      fontSize: "1rem",
      textTransform: "none",
      background: colors.gradientOrange,
      fontFamily: "GerberaBold",
    },
    addTaxesButton: {
      width: "100%",
      color: colors.white,
      fontSize: "1rem",
      textTransform: "none",
      background: colors.darkBlue,
      fontFamily: "GerberaBold",
      "&:hover": { background: colors.darkBlue },
    },
    removeTaxesButton: {
      width: "100%",
      color: colors.darkBlue,
      fontSize: "1rem",
      textTransform: "none",
      background: colors.white,
      fontFamily: "GerberaBold",
      "&:hover": { background: colors.white },
      border: "2px solid #365472",
    },
    buttonGrid: {
      marginTop: "10%",
      paddingBottom: "5%",
    },
    image: {
      width: "45%",
    },
    textField: {
      width: "100%",
    },
  });

  const classes = useStyles();
  return (
    <Grid container item className={classes.mainGrid} rowSpacing={3}>
      <Grid container item md={2} xs={2} mt={2}>
        <Link
          component={"button"}
          onClick={() => {
            navigate(-1);
          }}
        >
          <ArrowBackIosNewIcon color="warning" />
        </Link>
      </Grid>
      <Grid container item md={12} xs={12}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.headerBox}
        >
          <img
            src={
              props.utilityInfo.Images.filter(
                (image) => image.color === 1 && image.size === 1
              )[0].imagePath
            }
            className={classes.image}
          />
        </Grid>
        <Typography className={classes.utilityName}>
          {props.utilityInfo.PublicName}
        </Typography>
      </Grid>
      <Grid container item md={12} xs={12}>
        <Typography className={classes.fieldTitle}>
          {texts["prompt-choose-search-method"]}
        </Typography>
      </Grid>
      <Grid
        container
        item
        md={12}
        xs={12}
        justifyContent="flex-start"
        columnSpacing={5}
        rowSpacing={3}
      >
        <ButtonGroup
          defaultButtonStyle={defaultButtonStyle}
          selectedButtonStyle={selectedButtonStyle}
          state={searchMethods}
          sendValue={getSearchMethodValue}
        />
      </Grid>
      <SearchFields
        searchMethods={state.customerType}
        classes={classes}
        state={state}
        handleTextFieldChange={handleTextFieldChange}
      />
      <DynamicTaxSelector
        classes={classes}
        state={state}
        utilitySliceState={props.utilitySliceState}
        textFields={textFields}
        handleAddTextField={handleAddTextField}
        handleChange={handleChange}
        setTextFields={setTextFields}
        handleRemoveTextField={handleRemoveTextField}
        handleStartTransaction={handleStartTransaction}
        handleTextFieldChange={handleTextFieldChange}
      />
    </Grid>
  );
};

export default TaksatOffline;
